import { defineStore } from "pinia";
import { useAuthStore } from "./auth.store";
import FiltersService from "@/services/FiltersService";
import { i18n } from "@/main";

// Definicja store'a Pinia do obsługi filtrów na liście aktywności użytkowników
export const useUserActivityFiltersStore = defineStore({
  id: "userActivityFilter",
  state: () => ({
    // Domyślne filtry ostatnie 24h
    filters: {
      dateTimeStart: new Date(
        new Date().setDate(new Date().getDate() - 1)
      ).toISOString(),
      dateTimeEnd: new Date().toISOString(),
    },
    users: [],              // Lista użytkowników do wyboru w filtrach
    eventTypes: {           // Mapowanie eventów na ich nazwy
      1: "Logowanie do strony WWW",
      2: "Logowanie do stacji preselekcji",
      3: "Aktywność VMS", 
    },
    authStore: useAuthStore(), // Referencja do store’a autoryzacji (np. do obsługi błędów)
    requireFields: [],      // Pola wymagane (brakujące) przy walidacji
    error: null,            // Bieżący komunikat błędu
  }),
  getters: {},
  actions: {
    // Pobierz listę użytkowników do filtrowania (jeśli nie została jeszcze pobrana)
    getUsers() {
      if (this.users.length === 0) {
        FiltersService.getUsers()
          .then((data) => {
            const tmpArray = [];
            if (data && data.length > 0) {
              for (const item in data) {
                const us = data[item];
                tmpArray.push({ id: us.id, name: us.username });
              }
              this.users = tmpArray; // Aktualizacja stanu users
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },
    // Dodaj lub aktualizuj filtr
    addItem(name, value) {
      // console.log(`Adding filter: ${name} with value: ${value}`);
      this.filters[name] = value;
    },
    // Sprawdź czy wymagane dane zostały podane w filtrach
    checkRequireData() {
      this.requireFields = [];
      this.error = false;

      if (!this.filters.dateTimeEnd) {
        this.requireFields.push("dateTimeEnd");
      }
      if (!this.filters.dateTimeStart) {
        this.requireFields.push("dateTimeStart");
      }

      if (this.requireFields.length) {
        this.error = true;
        this.setErrors(i18n.global.t('required-parameter-missing'));
      }
    },
    // Ustaw błąd (i komunikat błędu w store autoryzacji)
    setErrors(error) {
      console.log(`Setting error: ${error}`);
      this.authStore.errorMessage = error;
    },
  },
});

// Obsługa Hot Module Replacement (do developmentu)
// if (typeof import.meta !== 'undefined' && import.meta.hot) {
//   import.meta.hot.accept(
//     acceptHMRUpdate(useUserActivityFiltersStore, import.meta.hot)
//   );
// }
